"use strict";

import React, { Component, PropTypes } from "react";
import { Modal, Button } from "react-bootstrap";
import ContactForm from "./ContactForm";

import { AccountActions, SessionActions, AlertActions } from "../../../actions";

class Contact extends Component {
  constructor() {
    super();

    this.state = {
      canSubmit: false
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._onFormValid = this._onFormValid.bind(this);
    this._handleClose = this._handleClose.bind(this);
  }

  static propTypes = {
    open: PropTypes.bool.isRequired
  };

  _handleClose() {
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  }
  render() {
    return (
      <Modal show={this.props.open} backdrop={true}>
        {/* <Modal.Header closeButton={true} onHide={this._handleClose}>
          <Modal.Title>
            Feel free to call Professor Rohit Aggarwal @ 860-303-4742.
          </Modal.Title>
          Kindly leave a voicemail if he can't take the call.
        </Modal.Header> */}
        <Modal.Body>
          <ContactForm ref="form" isValid={this._onFormValid} mentorEmail={this.props.mentorEmail} />
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              bsStyle="primary"
              disabled={!this.state.canSubmit}
              onClick={e => {
                this._handleSubmit(e);
              }}
            >
              Send
            </Button>
            <Button
              className="m-l-5p"
              type="submit"
              bsStyle="default"
              onClick={() => {
                this.props.onClose();
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  _handleSubmit(e) {
    e.preventDefault();
    const payload = this.refs.form.getModel();
    this.props.onSubmit(payload);
    this.props.onClose();
  }

  _onFormValid(isValid) {
    this.setState({ canSubmit: isValid });
  }
}

export default Contact;
